import React from "react";
import PropTypes from "prop-types";

import { ModerationListItemSwitch } from "@rdcs/dap-front-library";

import SettingsTabLayout from "../../../components/Settings/SettingsTabLayout";

const BreakScoreQuestionsTab = ({ loading, breakScoreQuestions, activate, swapOrder, isSwapingOrder }) => (
    <SettingsTabLayout
        title="Question de rupture pour patient insulinotraité"
        icon="informations"
        addButton={{
            link: "/configuration/ajouter-question-rupture",
            label: "Ajouter une question",
        }}
        isLoading={loading}
    >
        {breakScoreQuestions
            .sort((a, b) => (a.order < b.order ? -1 : 1))
            .map((breakScoreQuestion, index, breakScoreQuestions) => (
                <ModerationListItemSwitch
                    key={index}
                    label={breakScoreQuestion.label}
                    onChange={(value) =>
                        activate(breakScoreQuestion, value)
                            .then(() => value)
                            .catch(() => !value)
                    }
                    defaultChecked={breakScoreQuestion.active}
                    modifyLink={`/configuration/modifier-question-rupture/${breakScoreQuestion.id}`}
                    swapOrder={{
                        current: breakScoreQuestion,
                        onSwap: (item1, item2) => swapOrder(item1, item2),
                        prev: breakScoreQuestions[index - 1],
                        next: breakScoreQuestions[index + 1],
                        isSwapingOrder: isSwapingOrder,
                    }}
                    confirmModal={{
                        title: "Merci de confirmer",
                        body: "Voulez-vous désactiver cette question de rupture ?",
                    }}
                />
            ))}
    </SettingsTabLayout>
);

BreakScoreQuestionsTab.propTypes = {
    loading: PropTypes.bool.isRequired,
    breakScoreQuestions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            active: PropTypes.bool.isRequired,
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        })
    ).isRequired,
    activate: PropTypes.func.isRequired,
    swapOrder: PropTypes.func.isRequired,
    isSwapingOrder: PropTypes.bool.isRequired,
};

export default BreakScoreQuestionsTab;
